import { create } from 'zustand';

// The reveal flag lives outside the board store: the control is shell chrome and the painter
// reads it, so neither side owns the other. Phase 2's results panel shares this store.
interface QuizState {
  revealed: boolean;
  toggleReveal: () => void;
  /** The class-results panel. */
  resultsOpen: boolean;
  toggleResults: () => void;
  closeResults: () => void;
  /**
   * False (the default) floats the report as a draggable card over the board and reserves no
   * board width at all, so the quiz artboard keeps the size it has with the report closed.
   * True is the opt-in side-by-side column, and only that state widens --board-inset-right.
   */
  resultsDocked: boolean;
  toggleResultsDock: () => void;
  reset: () => void;
}

export const useQuizStore = create<QuizState>((set, get) => ({
  revealed: false,
  toggleReveal: () => set({ revealed: !get().revealed }),
  resultsOpen: false,
  toggleResults: () => set({ resultsOpen: !get().resultsOpen }),
  closeResults: () => set({ resultsOpen: false }),
  resultsDocked: false,
  toggleResultsDock: () => set({ resultsDocked: !get().resultsDocked }),
  reset: () => set({ revealed: false, resultsOpen: false, resultsDocked: false }),
}));
